export default "__VITE_PUBLIC_ASSET__3479ed30__"